import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_url from "../../libary/axios-home";

export const initialState = {};

export const updateAdminByIdApi = createAsyncThunk(
  "putAdminById/updateAdminByIdApi",
  async ({ id, data }) => {
    try {
      const response = await api_url.put("administrators/update/" + id, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
);

const putAdminByIdSlice = createSlice({
  name: "putAdminByIdSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(updateAdminByIdApi.pending, (state, action) => {
      state.status = "loading";
      // Add user to the state array
    });
    builder.addCase(updateAdminByIdApi.fulfilled, (state, action) => {
      // Add user to the state array
      state.status = "succeeded";
    });
    builder.addCase(updateAdminByIdApi.rejected, (state, action) => {
      // Add user to the state array
    });
  },
});

export default putAdminByIdSlice.reducer;
